'use es6';

import { APPLICATION_TOGGLE_FINDER, APPLICATION_HIDE_GLOBAL_CONTENT_MESSAGE, APPLICATION_SHOW_GLOBAL_CONTENT_MESSAGE, FINDER_ASSET_REVEAL_IN_FINDER, APPLICATION_SET_FINDER_WIDTH, APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START, APPLICATION_UPDATE_PREVIEWER, CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN, APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE, APPLICATION_DISMISS_RESPONSIVE_IMAGE_WARNING, APPLICATION_DISMISS_ICON_SET_WARNING, APPLICATION_DISMISS_ADVANCED_REL_WARNING, APPLICATION_DISMISS_ADVANCED_VIDEO_OPTIONS_WARNING, APPLICATION_ADD_PINNED_TAB, APPLICATION_REMOVE_PINNED_TAB } from 'DesignData/actions/ActionTypes';
import { saveUserSettings } from 'DesignData/actions/settings/user/User';
import { setESLintDemoErrors } from 'DesignData/actions/settings/user/JavaScriptLinter';
import { clearAllJsErrors } from 'DesignData/actions/EditorErrors';
export default (({
  dispatch
}) => next => action => {
  const result = next(action);
  /*
   * User Settings
   */

  switch (result.type) {
    case APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE:
    case APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE:
    case CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN:
    case APPLICATION_TOGGLE_FINDER:
    case APPLICATION_HIDE_GLOBAL_CONTENT_MESSAGE:
    case APPLICATION_SHOW_GLOBAL_CONTENT_MESSAGE:
    case FINDER_ASSET_REVEAL_IN_FINDER:
    case APPLICATION_SET_FINDER_WIDTH:
    case APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START:
    case APPLICATION_UPDATE_PREVIEWER:
    case APPLICATION_DISMISS_RESPONSIVE_IMAGE_WARNING:
    case APPLICATION_DISMISS_ICON_SET_WARNING:
    case APPLICATION_DISMISS_ADVANCED_REL_WARNING:
    case APPLICATION_ADD_PINNED_TAB:
    case APPLICATION_REMOVE_PINNED_TAB:
    case APPLICATION_DISMISS_ADVANCED_VIDEO_OPTIONS_WARNING:
      {
        dispatch(saveUserSettings());
        break;
      }

    default:
      break;
  }
  /*
   * JS Linter Adjustements
   */


  switch (result.type) {
    case APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE:
      {
        if (!result.data.isEnabled) {
          dispatch(clearAllJsErrors());
          dispatch(setESLintDemoErrors(null));
        }

        break;
      }

    default:
      break;
  }

  return result;
});